import { useGetMessages } from '@pba/react-chat-core';
import { createMessage } from 'models';
import { useMemo } from 'react';

type P = {
  chatroomId: string;
};

export const useChatroomMessagesQuery = ({ chatroomId }: P) => {
  const query = useGetMessages({
    filter: { chatroomId },
  });

  const data = useMemo(
    () =>
      query.data
        ? {
            ...query.data,
            pages: query.data.pages.map((page) => page.map((message) => createMessage(message))),
          }
        : null,
    [query.data],
  );

  return useMemo(
    () => ({
      ...query,
      data,
    }),
    [data, query],
  );
};
